import {companiesSelector, CompanySelectorProps, useGetAllCompaniesQuery} from "@ots-frontend/ots-data";
import {useMemo} from "react";
import {BaseCompanyMultiSelect, BaseCompanyMultiSelectProps} from "./BaseCompanyMultiSelect";

export type CompanyMultiSelectProps = Omit<BaseCompanyMultiSelectProps, "entities" | "loading"> & {
    selector?: CompanySelectorProps
}

export const CompanyMultiSelect = (props: CompanyMultiSelectProps) => {
    const {selector, ...rest} = props;

    const selectCompanies = useMemo(() => {
        return companiesSelector();
    }, []);

    const {companies, isLoading} = useGetAllCompaniesQuery(selector?.regionId, {
        selectFromResult: (result) => ({
            companies: selectCompanies(result, selector),
            isLoading: result.isLoading
        })
    });

    return <BaseCompanyMultiSelect entities={companies} loading={isLoading} {...rest} />;
};
